import http from '../../config/http-common';

//Usado somente se for realmente necessário algo fora do padrão GeneralCRUD.service.js
const path = "business/quote"

class service {

    getTotalsById(expeditionId) {

        return http.list(path + "/getTotals/"+expeditionId);
    }



}

export default new service();


